/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Pricing_Col_Per_MinuteInputs */



/**
* | output |
* | --- |
* | "Per minute" |
*
* @param {Model_Pricing_Col_Per_MinuteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_pricing_col_per_minute = /** @type {((inputs?: Model_Pricing_Col_Per_MinuteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Pricing_Col_Per_MinuteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Pro Minute")
	return /** @type {LocalizedString} */ ("Per minute")
});